import React from 'react';
import { SectionHeading } from './SectionHeading';
import { scatteredFinds, systemGives } from '../data/content';
export function IdeasVsSystem() {
  return <section className="bg-cream px-4 py-6 sm:px-6" data-id="element-108" data-mp="3c460mv2gbkjo">
      <SectionHeading size="lg" data-id="element-109" data-mp="3q0t5rl4k5h0o">
        ⚠️ Having activity ideas isn’t the same as having an activity system
      </SectionHeading>

      <p className="mx-auto mt-3 max-w-2xl text-center text-[13px] font-medium leading-snug text-graphite sm:text-sm" data-id="element-110" data-mp="3m10xzamznewd">
        Anyone can search online for “senior activity ideas.” You’ll find:
      </p>

      <ul className="mt-2 flex flex-wrap justify-center gap-1.5" data-id="element-111" data-mp="2t9h7d5o2aykc">
        {scatteredFinds.map(item => <li key={item} className="rounded border border-graphite/20 bg-white px-2 py-0.5 text-[11px] font-semibold text-graphite/70 line-through sm:text-xs" data-id="element-112" data-mp="374tde97o4bgk">
            {item}
          </li>)}
      </ul>

      <p className="mx-auto mt-3 max-w-2xl text-center text-[13px] font-medium leading-snug text-graphite sm:text-sm" data-id="element-113" data-mp="2ak162g4jz22v">
        But then you’re still responsible for turning all of that into something
        you can actually run.
      </p>

      <div className="mx-auto mt-3 max-w-2xl rounded-md border-2 border-navy bg-white p-3" data-id="element-114" data-mp="2x7q5uis91z2e">
        <p className="text-center text-[12px] font-extrabold uppercase tracking-wide text-navy" data-id="element-115" data-mp="322mcany8goz1">
          A professional activity system gives you:
        </p>
        <ul className="mt-2 flex flex-wrap justify-center gap-x-2 gap-y-1" data-id="element-116" data-mp="29cxai8dp8kwd">
          {systemGives.map(item => <li key={item} className="text-[12px] font-semibold text-graphite sm:text-[13px]" data-id="element-117" data-mp="2ebgw27odruo7">
              {item}
            </li>)}
        </ul>
      </div>

      <p className="mx-auto mt-3 max-w-2xl text-center text-[13px] font-medium leading-snug text-graphite sm:text-sm" data-id="element-118" data-mp="2oafvczn9adyj">
        Because your participants shouldn’t depend on whatever idea you happened
        to find five minutes before the activity begins.{' '}
        <strong className="font-bold text-navy" data-id="element-119" data-mp="1zl9164uliwyp">
          You should be able to open your system, choose what fits, and get
          started.
        </strong>
      </p>
    </section>;
}